import React from 'react';
import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from '@mui/material';
import { financialConditionGenerationStyles } from '~/modules/covenants/CovenantsDataApplicationForm/documentGeneration/financialCondition/styles.ts';
import type { IFinancialAssistanceTotalsProps } from '~/modules/covenants/CovenantsDataApplicationForm/documentGeneration/financialCondition/components/financialAssistance/types.ts';
import { formatThousandAmount } from '~/modules/covenants/CovenantsDataApplicationForm/documentGeneration/financialCondition/utils.ts';

export const FinancialAssistanceTotals: React.FC<IFinancialAssistanceTotalsProps> = ({
  totals,
  ariaLabel,
}) => (
  <>
    {totals.length > 0 && (
      <TableContainer sx={financialConditionGenerationStyles.currencyTotalsTable}>
        <Table size="small" aria-label={ariaLabel}>
          <TableHead>
            <TableRow>
              <TableCell>Валюта</TableCell>
              <TableCell align="right">Заборгованість, тис. од.</TableCell>
              <TableCell align="right">Прострочення, тис. од.</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {totals.map(({ currency, outstandingDebt, overdueDebt }) => (
              <TableRow key={currency.value}>
                <TableCell>{currency.label}</TableCell>
                <TableCell align="right">{formatThousandAmount(outstandingDebt)}</TableCell>
                <TableCell align="right">{formatThousandAmount(overdueDebt)}</TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    )}
  </>
);
